module.exports = __webpack_public_path__ + "img/paper_upload.89990d5b.svg";